import { IAdresse, IAdresseFilter, transformAdresseToAddress } from '@shared-ikp/model/address.model';
import { LegacyUmmeldungStatus, MeterPoint } from './meter-point.model';
import { MeterpointStatus } from './meterpoint-status.model';
import { Ummeldung } from '../../generated/model/ummeldung.model';
import StatusEnum = Ummeldung.StatusEnum;

export enum ZaehlpunktCriteriaType {
  FILTER = 'filter',
  SEARCH = 'search',
}

export interface IFindZaehlpunktCriteria {
  type?: ZaehlpunktCriteriaType;
}

export interface IFindZaehlpunktFilter extends IFindZaehlpunktCriteria {
  zaehlpunktStatus: string;
  sparte: string;
  adresseFilter: IAdresseFilter;
  unternehmenGpNr: string;
}

export interface IFindZaehlpunktSearch extends IFindZaehlpunktCriteria {
  searchTerm: string;
}

export interface IZaehlpunkt {
  zaehlpunktId: string;
  zaehlpunktnummer: string;
  status: string;
  zaehlerNr: string;
  geschaeftspartnerId: string;
  geschaeftspartnerNr: string;
  sparte: string;
  adresse: IAdresse;
  referenzname: string;

  verbrauchspreis?: string;
  vertragsbeginn?: string;
  vertragsbindung?: string;
  vertragsende?: string;
  vertragskontonummer?: string;
  vertragsnummer?: string;

  iban?: string;
  bezahlart?: string;
  grundpreis?: string;
  rechnungsAdresse?: IAdresse;
  rechnungsempfaengerName?: string;
  rechnungsversandArt?: string;
  rechnungsempfaengerEmail?: string;

  tarifName?: string;
  tarifKey?: string;
  unternehmenId?: string;
  legacyUmmeldungStatus: LegacyUmmeldungStatus;
  editableUmmeldungId?: string;
  ummeldungStatus: StatusEnum;
}

export interface IPreisbestandteil {
  preistyp: string;
  beschreibung: string;
  wert: string;
  einheit: string;
}

export type MeterPointExportRequest = {
  filter: IFindZaehlpunktFilter | IFindZaehlpunktSearch;
};

export function transformResponseToMeterPoint(zaehlpunktResponse: IZaehlpunkt): MeterPoint {
  const address = transformAdresseToAddress(zaehlpunktResponse.adresse);
  const rechnungsAdresse = transformAdresseToAddress(zaehlpunktResponse.rechnungsAdresse);

  return new MeterPoint({
    ...zaehlpunktResponse,
    status: zaehlpunktResponse.status as MeterpointStatus,
    adresse: address,
    rechnungsAdresse: rechnungsAdresse,
  });
}
